export const initialState = {
  branchName: "",
  branchDate: "",
  selectedSchedule: "",
  startCalendarDate: "",
  endCalendarDate: "",
  selectedDate: "",
  availableSchedules: [],
  loader: false,
  createdBooking: "",
  userData: {},
  appointmentError: false,
  appointmentErrorMessage: ""
};
